import { GlIcon, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import CiIcon from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/ci_icon/ci_icon.vue?vue3';
import { normalizeDownstreamPipelines, normalizeStages } from './utils/data_utils';
import DownstreamPipelines from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/pipeline_mini_graph/downstream_pipelines.vue?vue3';
import PipelineStages from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/pipeline_mini_graph/pipeline_stages.vue?vue3';
/**
 * Renders the pipeline mini graph.
 * All REST data passed in is formatted to GraphQL.
 */ export default {
    name: 'PipelineMiniGraph',
    arrowStyles: [
        'arrow-icon gl-inline-block gl-mx-1 gl-text-subtle !gl-align-middle'
    ],
    directives: {
        GlTooltip: GlTooltipDirective
    },
    components: {
        CiIcon,
        DownstreamPipelines,
        GlIcon,
        PipelineStages
    },
    props: {
        downstreamPipelines: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        downstreamCount: {
            type: Number,
            required: false,
            default: 0
        },
        isMergeTrain: {
            type: Boolean,
            required: false,
            default: false
        },
        pipelinePath: {
            type: String,
            required: false,
            default: ''
        },
        pipelineStages: {
            type: Array,
            required: true
        },
        upstreamPipeline: {
            type: Object,
            required: false,
            default: ()=>{}
        }
    },
    emits: [
        'job-action-executed',
        'mini-graph-stage-click'
    ],
    computed: {
        formattedDownstreamPipelines () {
            return normalizeDownstreamPipelines(this.downstreamPipelines);
        },
        formattedStages () {
            return normalizeStages(this.pipelineStages);
        },
        hasDownstreamPipelines () {
            return Boolean(this.latestDownstreamPipelines.length);
        },
        hasUpstreamPipeline () {
            return this.upstreamPipeline?.id;
        },
        latestDownstreamPipelines () {
            return this.formattedDownstreamPipelines;
        },
        upstreamPipelineStatus () {
            return this.upstreamPipeline?.detailedStatus || this.upstreamPipeline?.details?.status;
        },
        upstreamTooltipText () {
            return `${this.upstreamPipeline?.project?.name} - ${this.upstreamPipelineStatus?.label}`;
        }
    }
};
